export class SiteConfig {
    public static readonly PIECERATE_COMBINE_SHIFTS = 'piecerate_combine_shifts';
    public static readonly PIECERATE_NPT_DEFAULT = 'piecerate_npt_default';

    public static readonly SITE_RAD_TRANS_ENABLE = 'site_rlc_calcs_enable';
    public static readonly SITE_VOP_TRANS_ENABLE = "site_vop_trans_enable";
    public static readonly SITE_PECO_TRANS_ENABLE = "site_peco_trans_enable";
    public static readonly SITE_RM2_TRANS_ENABLE = "site_rm2_trans_enable";
    public static readonly SITE_TIME_ZONE = 'site_time_zone';

    public static readonly CHEP_IMPORT_CUSTOMER_IDS = 'chep_import_customer_ids';
    public static readonly CHEP_IMPORT_POOLER_IDS = 'chep_import_pooler_ids';
    public static readonly USER_SITE_MANAGER = 'user_site_manager';
    public static readonly USER_REGIONAL_MANAGER = 'user_regional_manager';
    public static readonly USER_DIRECTOR = 'user_director';
    public static readonly USER_WAM = 'user_wam';
    public static readonly NEWS_AND_NOTES = 'news_and_notes';
    public static readonly SAFETY_LEVEL = 'safety_level';
    public static readonly SITE_QUALITY_CONTROL_ENABLE = 'site_quality_control_enable';
    public static readonly IGPS_ORIGIN_CODE = "igps_origin_code";

    public static readonly NUM_SHIFTS = "num_shifts";

    siteId: string;
    configKey: string;
    configValue: string;

    constructor(siteId?: string, key?: string, value?: string) {
        if (arguments.length === 3) {
            this.siteId = siteId;
            this.configKey = key;
            this.configValue = value;
        }
    }

    GetValue<T>(): T {
        return <T>JSON.parse(this.configValue);
    }

    SetValue(val: any): void {
        this.configValue = JSON.stringify(val);
    }
}

export type NewsAndNotesConfig = { notes: string, timestamp: string };
export type SafetyLevelConfig = 'unknown' | 'low' | 'medium' | 'high';
export type SiteQualityControlEnableConfig = boolean;
